import { AvatarProps } from "@mui/material/Avatar/Avatar";
import { stringAvatar } from "hhn-commons";
import React from "react";
import { AvatarStyle } from "../organization/OrganizationList.style";
import theme from "../theme";

interface UserAvatarProps extends AvatarProps {
  alt: string;
  avatarSize: number;
  src?: string;
  onlyFirstNameInitial?: boolean;
  isActive?: boolean;
}
export const UserAvatar = ({
  src,
  alt,
  onlyFirstNameInitial = false,
  avatarSize,
  isActive = false,
  ...restProps
}: UserAvatarProps) => {
  return (
    <AvatarStyle
      src={src}
      alt={alt}
      sx={{
        height: avatarSize,
        width: avatarSize,
        bgcolor: isActive
          ? theme.palette.common.white
          : theme.palette.secondary.main,
        color: isActive
          ? theme.palette.secondary.main
          : theme.palette.common.white,
      }}
      data-testid="profile-avatar"
      {...restProps}
    >
      {stringAvatar(alt, onlyFirstNameInitial)}
    </AvatarStyle>
  );
};
